import React, { memo } from "react";

function Index({ category = "all", setCategory }) {
  return (
    <div className="row clearfix">
      <div className="col-lg-7">
        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <span
              className={`nav-table-tab nav-link ${
                category === "all" ? "active" : ""
              }`}
              onClick={() => {
                setCategory("all");
                //   setPage(1);
                //   getOverviewList(id, dispatch, 1, "ticket", "");
              }}
            >
              Overview
            </span>
          </li>
          <li className="nav-item">
            <span
              className={`nav-link nav-table-tab ${
                category === "internal" ? "active" : ""
              }`}
              onClick={() => {
                setCategory("internal");
                //   setPage(1);
                //   getOverviewList(id, dispatch, 1, "ticket", "InProgress");
              }}
            >
              Internal
            </span>
          </li>
          <li className="nav-item">
            <span
              className={`nav-link nav-table-tab ${
                category === "external" ? "active" : ""
              }`}
              onClick={() => {
                setCategory("external");
                //   setPage(1);
                //   getOverviewList(id, dispatch, 1, "ticket", "Close");
              }}
            >
              External
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default memo(Index);
